<script setup lang="ts">
const { d, locale, t } = useI18n()
</script>

<template>
  <div
    class="max-w-screen grid min-h-screen w-full grid-rows-[auto_1fr_auto_auto] font-poppins"
  >
    <CustomerHeader />
    <div>
      <slot />
    </div>
    <div class="z-20 bg-white py-36">
      <CustomerFAQ />
    </div>
    <CustomerFooter />
  </div>
</template>
